/* global window */
'use strict';

module.exports = {
    getRequestOptions: getRequestOptions,
};

function getRequestOptions() {
    // If not on the live site, Basic auth is in place, so we send "phoenix:phoenix"
    // credentials which the server is set up to recognize for all environments.
    // (This auth mechanism is more to keep content from leaking into search engines
    // than anything else, so it's OK that we expose it in client-side code.)
    var opts = {};
    if (window.location.href.match(/\.saymedia\.com|\.nip\.io|localhost/)) {
        opts.headers = {
            Authorization: 'Basic cGhvZW5peDpwaG9lbml4',
        };
    }
    return opts;
}
